import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgramImpactWidget } from '../../models/loyalty-dashboard.model';

@Component({
  selector: 'app-program-impact-widget',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="impact" *ngIf="data as w; else empty">
      <div class="impact__main">
        <p class="impact__eyebrow">Revenue loyalty added · {{ w.periodLabel }}</p>

        <div class="impact__headline">
          <span class="impact__amount">{{ w.addedRevenue | currency : 'USD' : 'symbol' : '1.0-0' }}</span>
          <span class="impact__delta" *ngIf="w.vsExpectedPercent != null">
            {{ w.vsExpectedPercent > 0 ? '+' : '' }}{{ w.vsExpectedPercent | number : '1.0-1' }}% vs. before joining
          </span>
        </div>

        <p class="impact__explain">
          <ng-container *ngIf="w.rangeLow != null && w.rangeHigh != null">
            Likely range {{ w.rangeLow | currency : 'USD' : 'symbol' : '1.0-0' }} –
            {{ w.rangeHigh | currency : 'USD' : 'symbol' : '1.0-0' }}.
          </ng-container>
          This is the extra revenue your members generate compared with how they spent before they joined<ng-container
            *ngIf="w.rewardsRedeemed != null"
            >, after subtracting {{ w.rewardsRedeemed | currency : 'USD' : 'symbol' : '1.0-0' }} in rewards
            redeemed</ng-container
          >.
        </p>
      </div>

      <div class="impact__rail" *ngIf="w.sinceJoining != null || w.returnOnPlanCost != null || w.comparedAgainst">
        <div class="impact__stat" *ngIf="w.sinceJoining != null">
          <span class="impact__stat-label">Since joining</span>
          <span class="impact__stat-value">{{ w.sinceJoining | currency : 'USD' : 'symbol' : '1.0-0' }}</span>
        </div>
        <div class="impact__stat" *ngIf="w.returnOnPlanCost != null">
          <span class="impact__stat-label">Return on plan cost</span>
          <span class="impact__stat-value">{{ w.returnOnPlanCost | number : '1.1-1' }}×</span>
        </div>
        <div class="impact__stat" *ngIf="w.comparedAgainst">
          <span class="impact__stat-label">Compared against</span>
          <span class="impact__stat-value impact__stat-value--text">{{ w.comparedAgainst }}</span>
        </div>
      </div>
    </div>

    <ng-template #empty>
      <div class="impact impact--empty">
        <p class="impact__eyebrow">Revenue loyalty added</p>
        <p class="impact__explain">
          We'll estimate the extra revenue your program drives once there's enough member history to compare.
        </p>
      </div>
    </ng-template>
  `,
  styleUrl: './program-impact-widget.component.scss',
})
export class ProgramImpactWidgetComponent {
  @Input() data: ProgramImpactWidget | null = null;
}
